var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.2,
    height: 35.2,
    rx: 17.6,
    fill: "#F1F1F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4136_15649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.01 10.8891C21.2156 10.8891 19.5973 10.1851 18.3835 9.0502C17.9627 8.65775 17.3154 8.65775 16.8946 9.0502C15.6808 10.1851 14.0624 10.8891 12.2681 10.8891C11.8534 10.8891 11.4488 10.8486 11.0543 10.7758C10.3806 10.6504 9.75757 11.1541 9.75757 11.8378V16.7759C9.75757 23.5366 15.0011 26.1139 16.933 26.8341C17.3882 27.004 17.8858 27.004 18.341 26.8341C20.2729 26.1179 25.5164 23.5488 25.5164 16.7759V11.8378C25.5164 11.1541 24.8913 10.6483 24.2197 10.7758C23.8273 10.8486 23.4227 10.8891 23.0059 10.8891H23.01Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.597 21.178C16.597 21.178 16.5808 21.178 16.5727 21.178C16.2996 21.172 16.0386 21.0526 15.8525 20.8523L13.1073 17.8685C12.7291 17.4578 12.7554 16.8165 13.166 16.4382C13.5767 16.0599 14.218 16.0862 14.5942 16.4969L16.6293 18.71L20.9929 14.4112C21.3914 14.0188 22.0306 14.0228 22.4231 14.4213C22.8155 14.8199 22.8095 15.4591 22.413 15.8516L17.303 20.8847C17.1128 21.0708 16.8579 21.176 16.5929 21.176L16.597 21.178Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4136_15649"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7609,
    height: 18.2067,
    fill: "white",
    transform: "translate(9.75916 8.75488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.4838928d67993ac074f3ae4bc1b516aa.svg";
export { ForwardRef as ReactComponent };